import React from 'react';
import ReactDOM from 'react-dom/client'
import Header from './Components/Header';
// import { createBrowserRouter,Outlet,RouterProvider } from 'react-router';
import { createBrowserRouter, Outlet, RouterProvider } from 'react-router-dom';
 import Footer from './Components/Footer';
 import img from './assets/person-picking-grapes-spending-time-vineyard.jpg'
import './App.css';

const App = () => {
    return (
      <div style={{margin:0}}>
        <Header />
        <img src={img} alt="Background" className="bg-image" />
          <Outlet />
          <Footer />
        </div>
    );
  };

  export default App;
